<template>
  <div>
    <v-card class="transparent" flat>
      <v-card-title
        v-if="!helpers.dataIsLoading"
        class="px-0"
        :class="
          $vuetify.breakpoint.smAndDown ? 'subtitle-1 font-weight-medium' : ''
        "
        >Meine letzten Abrechnungszettel<v-spacer></v-spacer>
        <v-btn
          text
          outlined
          small
          :to="{
            name: 'accounting-payslips',
          }"
          >Alle anzeigen</v-btn
        >
      </v-card-title>
      <div>
        <v-skeleton-loader
          v-if="helpers.dataIsLoading"
          elevation="2"
          type="card-heading, list-item-two-line, divider, card-heading, list-item-two-line, divider, card-heading, list-item-two-line"
        ></v-skeleton-loader>
        <v-data-iterator
          v-else
          :items="payslips"
          no-data-text="Keine Abrechnungszettel vorhanden"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:default="props">
            <v-card>
            <v-row no-gutters>
              <v-col
                v-for="(payslip, index) in props.items"
                :key="index"
                cols="12"
              >
              <v-list-item :to="{
        name: 'accounting-payslips-details',
        params: { itemId: payslip.meta.id },
      }">
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium">{{ payslip.batch.title }}</v-list-item-title>
      <v-list-item-subtitle>
        <p style="line-height: 1.6" class="mb-0">
          <pre class="font-weight-medium"
            ><v-icon small left>mdi-sigma</v-icon>{{ payslip.summary.totalCompensation.amount }} {{ payslip.summary.totalCompensation.currency }}</pre
          >
          <v-icon small left>mdi-cash-sync</v-icon>
          {{ getPayrollTypeText(payslip.type) }}<br />
          <v-icon small left>mdi-cash-clock</v-icon
          ><span v-if="payslip.paidAt">
            Ausgezahlt am
            {{ timestampConverter(payslip.paidAt) }}</span
          >
          <span v-else>Auszahlung angewiesen am {{ timestampConverter(payslip.instructedPaymentAt) }}</span>
        </p>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <payslip-status-chip :status="payslip.status" small>
        </payslip-status-chip>
    </v-list-item-action>
      </v-list-item>
      <v-divider v-if="props.items.length != index + 1"></v-divider>
              </v-col>
            </v-row>
            </v-card>
          </template>
        </v-data-iterator>
      </div>
    </v-card>
  </div>
</template>

<script>
import { ACCOUNTING } from "@/store/modules.js";
import { GET_PAYSLIPS } from "@/store/action-types.js";
import PayslipStatusChip from "@/components/accounting/payslips/PayslipStatusChip.vue";
export default {
  name: "self-service-open-payslips",
  props: {},
  components: {
    PayslipStatusChip,
  },
  data() {
    return {
      helpers: {
        dataIsLoading: false,
      },
    };
  },
  computed: {
    payslips() {
      return this.$store.state.accounting.payslips;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$store.dispatch(`${ACCOUNTING}${GET_PAYSLIPS}`, {
        organizationId: this.$route.params.organizationId,
        query: {
          queryIsFiltered: true,
          onlyOwn: true,
        },
        paginationLimit: 3,
      });
    },
    timestampConverter(timestamp) {
      const options = {
        weekday: "short",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
    getPayrollTypeText(type) {
      switch (type) {
        case "regular":
          return "Regulärer Turnus";
        case "special":
          return "Sonderzahlung";
        default:
          return "Unbekannt";
      }
    },
  },
};
</script>
